<template>
  <div class="form_wrap">
    <div class="form_content_wrap" :class="formConfig.type=='R'?'readonly_wrap':''">
      <div class="form" v-loading="loading">
        <!-- 无从表 -->
        <div
          v-if="!item.hidden&&!item.hasChildren"
          class="form_item"
          :class="item.width?item.width:''"
          v-for="(item, index) in formConfig.form"
          :key="index"
        >
          <div
            class="lab"
            :style="{flex:formConfig.labelWidth?('0 0 '+formConfig.labelWidth+'px'):'0 0 4vw'}"
            :class="{'required':item.required&&item.required&&formConfig.type!='R'}"
          >{{item.label}}：</div>
          <div class="con">
            <div class="con_inp_wrap">
              <el-input
                size="mini"
                v-if="item.kjlx=='input'"
                v-model="item.value"
                :placeholder="'请输入'+item.label"
                :disabled="item.readonly||formConfig.type=='R'"
                @change="changeHandle(item,formConfig.form)"
              ></el-input>
              <el-input
                size="mini"
                v-if="item.kjlx=='textarea'"
                type="textarea"
                autosize
                v-model="item.value"
                :placeholder="'请输入'+item.label"
                :disabled="item.readonly||formConfig.type=='R'"
                @change="changeHandle(item,formConfig.form)"
              ></el-input>
              <el-input
                size="mini"
                v-if="item.kjlx=='number'"
                type="number"
                v-model="item.value"
                :placeholder="'请输入'+item.label"
                :disabled="item.readonly||formConfig.type=='R'"
                @change="changeHandle(item,formConfig.form)"
              ></el-input>
              <el-date-picker
                v-if="item.kjlx=='date'"
                v-model="item.value"
                type="date"
                value-format="yyyy-MM-dd"
                size="mini"
                class="my_form"
                :disabled="item.readonly||formConfig.type=='R'"
                placeholder="选择日期"
                @change="changeHandle(item,formConfig.form)"
              ></el-date-picker>
              <el-date-picker
                v-if="item.kjlx=='datetime'"
                v-model="item.value"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="mini"
                class="my_form"
                :disabled="item.readonly||formConfig.type=='R'"
                placeholder="选择日期"
                @change="changeHandle(item,formConfig.form)"
              ></el-date-picker>
              <el-radio-group
                :disabled="item.readonly||formConfig.type=='R'"
                v-model="item.value"
                v-if="item.kjlx=='radio'"
              >
                <el-radio
                  :label="item2.value"
                  v-for="(item2, index2) in formatList(item)"
                  @change="changeHandle(item,formConfig.form)"
                  :key="index2"
                >{{item2.label}}</el-radio>
              </el-radio-group>
              <el-select
                size="mini"
                v-if="item.kjlx=='select'"
                v-model="item.value"
                :placeholder="'请选择'+item.label"
                class="my_form"
                :disabled="item.readonly||formConfig.type=='R'"
                @change="changeHandle(item,formConfig.form)"
              >
                <el-option
                  v-for="(item2, index2) in formatList(item)"
                  :key="index2"
                  :value="item2.value"
                  :label="item2.label"
                ></el-option>
              </el-select>
              <el-select
                size="mini"
                v-if="item.kjlx=='selects'"
                multiple
                :collapse-tags="formConfig.type=='R'?false:true"
                filterable
                v-model="item.value"
                :placeholder="'请选择'+item.label"
                class="my_form"
                :disabled="item.readonly||formConfig.type=='R'"
                @change="changeHandle(item,formConfig.form)"
              >
                <el-option
                  v-for="(item2, index2) in formatList(item)"
                  :key="index2"
                  :value="item2.value"
                  :label="item2.label"
                ></el-option>
              </el-select>
              <el-input
                size="mini"
                v-if="item.kjlx=='position'"
                v-model="item.value"
                :placeholder="'请选择坐标'"
                :disabled="true"
              ></el-input>
              <el-input
                size="mini"
                v-if="item.kjlx=='validateCode'"
                type="number"
                v-model="item.value"
                :placeholder="'请输入'+item.label"
                :disabled="item.readonly||formConfig.type=='R'"
                @change="changeHandle(item,formConfig.form)"
              ></el-input>
              <el-button
                v-if="item.kjlx=='validateCode'"
                @click="getPhoneCode(item,formConfig.form)"
                type="primary"
                size="mini"
                :disabled="phoneCodeSec<60"
              >{{phoneCodeSec<60?phoneCodeSec+'秒后获取':'获取验证码'}}</el-button>
              <el-button
                v-if="item.kjlx=='position'"
                @click="choosePosition(item,formConfig.form)"
                type="primary"
                size="mini"
              >选择坐标</el-button>
              <el-button
                v-if="item.buttonFunction&&item.kjlx!='position'&&item.kjlx!='validateCode'&&formConfig.type!='R'"
                @click="clickHandle(item,formConfig.form)"
                type="primary"
                size="mini"
                icon="el-icon-more"
              ></el-button>

              <div class="fj" v-if="item.kjlx=='file'">
                <el-input size="mini" v-model="item.value" disabled :placeholder="item.label"></el-input>
                <el-button-group class="upload">
                  <el-button
                    @click="upload(item)"
                    v-if="formConfig.type!='R'"
                    type="primary"
                    size="mini"
                    icon="el-icon-upload"
                  ></el-button>
                  <el-button @click="viewFile(item)" type="primary" size="mini" icon="el-icon-view"></el-button>
                </el-button-group>
              </div>
            </div>
            <div class="remark_wrap" v-html="item.remark"></div>
          </div>
          <!-- <div class="con" v-if="formConfig.type=='R'">
            <div class="con_inp_wrap">
              <div class="fj" v-if="item.kjlx=='file'">
                <el-input size="mini" v-model="item.value" disabled :placeholder="item.label"></el-input>
                <el-button-group class="upload">
                  <el-button
                    @click="upload(item)"
                    v-if="formConfig.type!='R'"
                    type="primary"
                    size="mini"
                    icon="el-icon-upload"
                  ></el-button>
                  <el-button @click="viewFile(item)" type="primary" size="mini" icon="el-icon-view"></el-button>
                </el-button-group>
              </div>
              <div v-else>{{item.format?item.format(item):item.value}}</div>
            </div>
            <div class="remark_wrap" v-html="item.remark"></div>
          </div>-->
        </div>
        <!-- 有从表 -->
        <div
          class="has_child_item"
          v-if="item.hasChildren&&!item.hidden"
          v-for="(item, index) in formConfig.form"
          :key="index"
        >
          <div
            class="has_child_item_title"
            :class="{'required':item.required&&formConfig.type!='R'}"
          >
            {{item.label}}
            <el-button-group class="btn_group" v-if="formConfig.type!='R'">
              <el-button type="primary" icon="el-icon-plus" @click="addItem(item)" size="mini"></el-button>
              <el-button
                type="primary"
                icon="el-icon-document-copy"
                @click="copyItem(item)"
                size="mini"
              ></el-button>
            </el-button-group>
          </div>
          <div class="has_child_item_content" v-if="item.value&&item.value.length">
            <el-tabs
              type="card"
              v-model="item.tabModel"
              :closable="formConfig.type!='R'"
              @tab-remove="removeTab($event,item.value,item)"
              @tab-click="tabClickHandle($event,item)"
            >
              <el-tab-pane
                v-for="(item2, index2) in item.value"
                :key="index2"
                :label="item.label+(index2+1)"
                :name="index2+''"
              >
                <div class="form form_2_level">
                  <div class="tools">
                    <el-button
                      type="primary"
                      round
                      v-if="item.helpButton&& formConfig.type!='R'"
                      @click="item.helpButton.helpFunc(item2)"
                      size="mini"
                    >{{item.helpButton.label}}</el-button>
                  </div>
                  <div
                    v-if="!item3.hidden&&!item3.hasChildren"
                    :class="item3.width?item3.width:''"
                    class="form_item"
                    v-for="(item3, index3) in item.config"
                    :key="index3"
                  >
                    <div
                      class="lab"
                      :style="{flex:formConfig.childLabelWidth?('0 0 '+formConfig.childLabelWidth+'px'):'0 0 4vw'}"
                      :class="{'required':item3.required&&formConfig.type!='R'}"
                    >{{item3.label}}：</div>
                    <div class="con">
                      <div class="con_inp_wrap">
                        <el-input
                          size="mini"
                          v-if="item3.kjlx=='input'"
                          v-model="item2[index3]"
                          :placeholder="'请输入'+item3.label"
                          :disabled="item3.readonly||formConfig.type=='R'"
                          @change="changeChildHandle(item3,item2,formConfig.form)"
                        ></el-input>
                        <el-input
                          size="mini"
                          v-if="item3.kjlx=='number'"
                          type="number"
                          v-model="item2[index3]"
                          :disabled="item3.readonly||formConfig.type=='R'"
                          @change="changeChildHandle(item3,item2,formConfig.form)"
                          :placeholder="'请输入'+item3.label"
                        ></el-input>
                        <el-input
                          size="mini"
                          v-if="item3.kjlx=='textarea'"
                          type="textarea"
                          autosize
                          v-model="item2[index3]"
                          :disabled="item3.readonly||formConfig.type=='R'"
                          @change="changeChildHandle(item3,item2,formConfig.form)"
                          :placeholder="'请输入'+item3.label"
                        ></el-input>
                        <el-select
                          size="mini"
                          v-if="item3.kjlx=='select'"
                          v-model="item2[index3]"
                          :placeholder="'请选择'+item3.label"
                          :disabled="item3.readonly||formConfig.type=='R'"
                          @change="changeChildHandle(item3,item2,formConfig.form)"
                          class="my_form"
                        >
                          <el-option
                            v-for="(item4, index4) in formatList(item3)"
                            :key="index4"
                            :value="item4.value"
                            @change="changeChildHandle(item3,item2,formConfig.form)"
                            :label="item4.label"
                          ></el-option>
                        </el-select>
                        <el-date-picker
                          v-if="item3.kjlx=='date'"
                          v-model="item2[index3]"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :disabled="item3.readonly||formConfig.type=='R'"
                          @change="changeChildHandle(item3,item2,formConfig.form)"
                          size="mini"
                          class="my_form"
                          placeholder="选择日期"
                        ></el-date-picker>
                        <el-radio-group
                          :disabled="item3.readonly||formConfig.type=='R'"
                          v-model="item2[index3]"
                          v-if="item3.kjlx=='radio'"
                        >
                          <el-radio
                            :label="item4.value"
                            v-for="(item4, index4) in formatList(item3)"
                            :key="index4"
                            @change="changeChildHandle(item3,item2,formConfig.form)"
                          >{{item4.label}}</el-radio>
                        </el-radio-group>
                        <el-button
                          v-if="item3.buttonFunction&&formConfig.type!='R'"
                          @click="clickChildHandle(item3,item2,formConfig.form,item)"
                          type="primary"
                          size="mini"
                          icon="el-icon-more"
                        ></el-button>
                        <div class="fj" v-if="item3.kjlx=='file'">
                          <el-input
                            size="mini"
                            v-model="item2[index3]"
                            disabled
                            :placeholder="item3.label"
                          ></el-input>
                          <el-button-group class="upload">
                            <el-button
                              @click="upload(item3,item.value[index2])"
                              v-if="formConfig.type!='R'"
                              type="primary"
                              size="mini"
                              icon="el-icon-upload"
                            ></el-button>
                            <el-button
                              @click="viewFile(item3,item.value[index2])"
                              type="primary"
                              size="mini"
                              icon="el-icon-view"
                            ></el-button>
                          </el-button-group>
                        </div>
                      </div>
                      <div class="remark_wrap" v-html="item3.remark"></div>
                    </div>
                    <!-- <div class="con" v-else>
                      <div class="con_inp_wrap">
                        <div class="fj" v-if="item3.kjlx=='file'">
                          <el-input
                            size="mini"
                            v-model="item2[index3]"
                            disabled
                            :placeholder="item3.label"
                          ></el-input>
                          <el-button-group class="upload">
                            <el-button
                              @click="upload(item3,item.value[index2])"
                              v-if="formConfig.type!='R'"
                              type="primary"
                              size="mini"
                              icon="el-icon-upload"
                            ></el-button>
                            <el-button
                              @click="viewFile(item3,item.value[index2])"
                              type="primary"
                              size="mini"
                              icon="el-icon-view"
                            ></el-button>
                          </el-button-group>
                        </div>
                        <div v-else-if="item3.kjlx=='select'||item3.kjlx=='radio'">{{formatListInfo(item2[index3],item3.list)}}</div>
                        <div v-else>{{item2[index3]}}</div>
                      </div>
                      <div class="remark_wrap" v-html="item3.remark"></div>
                    </div>-->
                  </div>
                  <!-- 二级从表 -->
                  <div
                    class="has_child_item"
                    v-if="item3.hasChildren"
                    v-for="(item3, index3) in item.config"
                    :key="index3"
                  >
                    <div
                      class="has_child_item_title"
                      :class="{'required':item3.required&&item.required&&formConfig.type!='R'}"
                    >
                      {{item3.label}}
                      <el-button-group class="btn_group" v-if="formConfig.type!='R'">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="addItemChild(item3,item2[index3])"
                          size="mini"
                        ></el-button>
                        <el-button
                          type="primary"
                          icon="el-icon-document-copy"
                          @click="copyItemChild(item3,item2[index3])"
                          size="mini"
                        ></el-button>
                      </el-button-group>
                    </div>
                    <div class="has_child_item_content" v-if="item2[index3].length">
                      <el-tabs
                        type="card"
                        v-model="item3.tabModel"
                        :closable="formConfig.type!='R'"
                        @tab-remove="removeTab($event,item2[index3],item3)"
                      >
                        <el-tab-pane
                          v-for="(item4, index4) in item2[index3]"
                          :key="index4"
                          :label="item3.label+(index4+1)"
                          :name="index4+''"
                        >
                          <div class="form form_3_level">
                            <div class="tools">
                              <el-button
                                type="primary"
                                round
                                v-if="item3.helpButton&&formConfig.type!='R'"
                                @click="item3.helpButton.helpFunc(item4)"
                                size="mini"
                              >{{item3.helpButton.label}}</el-button>
                            </div>
                            <div
                              v-if="!item5.hidden"
                              class="form_item"
                              v-for="(item5, index5) in item3.config"
                              :key="index5"
                            >
                              <div
                                class="lab"
                                :style="{flex:formConfig.childLabelWidth?('0 0 '+formConfig.childLabelWidth+'px'):'0 0 4vw'}"
                                :class="{'required':item5.required&&item.required&&formConfig.type!='R'}"
                              >{{item5.label}}：</div>
                              <div class="con">
                                <el-input
                                  size="mini"
                                  v-if="item5.kjlx=='input'"
                                  v-model="item4[index5]"
                                  :disabled="item5.readonly||formConfig.type=='R'"
                                  :placeholder="'请输入'+item5.label"
                                ></el-input>
                                <el-input
                                  size="mini"
                                  v-if="item5.kjlx=='number'"
                                  type="number"
                                  :disabled="item5.readonly||formConfig.type=='R'"
                                  v-model="item4[index5]"
                                  :placeholder="'请输入'+item5.label"
                                ></el-input>
                                <el-select
                                  size="mini"
                                  v-if="item5.kjlx=='select'"
                                  v-model="item4[index5]"
                                  :placeholder="'请选择'+item5.label"
                                  :disabled="item5.readonly||formConfig.type=='R'"
                                  class="my_form"
                                >
                                  <el-option
                                    v-for="(item6, index6) in formatList(item5)"
                                    :key="index6"
                                    :value="item6.value"
                                    :label="item6.label"
                                  ></el-option>
                                </el-select>
                                <el-button
                                  v-if="item5.buttonFunction&&item5.kjlx!='position'&&item5.kjlx!='validateCode'&&formConfig.type!='R'"
                                  @click="clickGrandsonHandle(item4[index5],item5,item3,item)"
                                  type="primary"
                                  size="mini"
                                  icon="el-icon-more"
                                ></el-button>
                              </div>
                              <!-- <div class="con" v-else>{{item4[index5]}}</div> -->
                            </div>
                          </div>
                        </el-tab-pane>
                      </el-tabs>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
    <common-upload :uploadConfig="uploadConfig"></common-upload>
    <common-position-choose v-if="showMap"></common-position-choose>
  </div>
</template>

<script>
import CommonUpload from "@/components/CommonUpload/index";
import CommonPositionChoose from "@/components/CommonPositionChoose/index";
import { Colgroup } from "vxe-table";
export default {
  components: {
    CommonUpload,
    CommonPositionChoose
  },
  props: {
    formConfig: {}
  },
  name: "CommonFormCurd",
  // watch: {
  //   formConfig: {
  //     deep: true,
  //     handler: (newVal, oldVal) => {
  //     }
  //   }
  // },
  methods: {
    inputData(d) {
      var f = this.formConfig.form;
      for (var i in f) {
        this.$set(f[i], "value", d[i]);
      }
    },
    $http(obj) {
      let param = {
        type: "POST",
        contentType: "application/json;charset=utf-8",
        dataType: "json",
        headers: {
          "bg-token": this.$store.state.user.token
        },
        ...obj
      };
      if (param.data && param instanceof Object) {
        param.data = JSON.stringify(obj.data);
      }
      return $.ajax(param);
    },
    formatListInfo(value, list) {
      if (list.length && value) {
        var tmp = list.find(e => {
          return e.value == value;
        });
        if (tmp) {
          return tmp.label;
        } else {
          return [];
        }
      } else {
        return value;
      }
    },
    async getPhoneCode(item) {
      if (!item.value) {
        return this.$message.warning("请先填写手机号");
      }
      if (item.validateCodeUrl) {
        let res = await this.$api.post(item.validateCodeUrl, {
          phone: item.value
        });
        if (res.success) {
          this.formConfig.form[item.idZdname].value=res.data.id
          this.phoneCodeSec--;
          this.phoneCodeTimer = setInterval(() => {
            this.phoneCodeSec--;
            if (this.phoneCodeSec == 0) {
              clearInterval(this.phoneCodeTimer);
              this.phoneCodeSec = 60;
            }
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    confirmPosition(point) {
      this.tmpPositionObj.value = point.lng + "," + point.lat;
    },
    choosePosition(item, form) {
      this.tmpPositionObj = item;
      this.showMap = true;
    },
    formatList(item) {
      if (this.formConfig.env == "vue") {
        return item.list;
      } else {
        if (item.formatList && window[item.formatList]) {
          var arr = window[item.formatList](item);
          if (arr instanceof Array) {
            return arr;
          } else {
            return [];
          }
        } else {
          return item.list;
        }
      }
    },
    clickGrandsonHandle(value, item, parItem, parparItem) {
      if (this.formConfig.env == "vue") {
        var data =
          parparItem.value[parseInt(parparItem.tabModel)][parItem.zdname][
            parseInt(parItem.tabModel)
          ];
        var parData = parparItem.value[parseInt(parparItem.tabModel)];
        this.$parent[item.buttonFunction](
          value,
          item,
          parItem,
          parparItem,
          data,
          parData
        );
      } else {
      }
    },
    clickChildHandle(item, data, form, parItem) {
      if (this.formConfig.env == "vue") {
        if (item.buttonFunction && this.$parent[item.buttonFunction]) {
          this.$parent[item.buttonFunction](
            data[item.zdname],
            item,
            data,
            form,
            parItem
          );
        }
      } else {
        if (item.buttonFunction && window[item.buttonFunction]) {
          window[item.buttonFunction](
            data[item.zdname],
            item,
            data,
            form,
            parItem
          );
        }
      }
    },
    clickHandle(item, form) {
      if (this.formConfig.env == "vue") {
        if (item.buttonFunction && this.$parent[item.buttonFunction]) {
          this.$parent[item.buttonFunction](item.value, item, form);
        }
      } else {
        if (item.buttonFunction && window[item.buttonFunction]) {
          window[item.buttonFunction](item.value, item, form);
        }
      }
    },
    changeChildHandle(item, data, form) {
      if (this.formConfig.env == "vue") {
        if (item.changeFunction && this.$parent[item.changeFunction]) {
          this.$parent[item.changeFunction](
            data[item.zdname],
            item,
            data,
            form
          );
        }
      } else {
        if (item.changeFunction && window[item.changeFunction]) {
          window[item.changeFunction](data[item.zdname], item, data, form);
        }
      }
    },
    changeHandle(item, form) {
      if (this.formConfig.env == "vue") {
        if (item.changeFunction && this.$parent[item.changeFunction]) {
          this.$parent[item.changeFunction](item.value, item, form);
        }
        if(item.changeFunction && this.$parent.$parent[item.changeFunction]){
          this.$parent.$parent[item.changeFunction](item.value, item, form);
        }
      } else {
        if (item.changeFunction && window[item.changeFunction]) {
          window[item.changeFunction](item.value, item, form);
        }
      }
    },
    upload(item, item2) {
      this.uploadConfig.show = true;
      this.uploadConfig.type = "edit";
      if (item2) {
        this.uploadConfig.files = item2[item.zdname];
        this.fileZdname = item.zdname;
        this.tmpChosenData2 = item2;
      } else {
        this.uploadConfig.files = item.value;
        this.tmpChosenData = item;
      }
    },
    viewFile(item, item2) {
      this.uploadConfig.show = true;
      this.uploadConfig.type = "view";
      if (item2) {
        this.uploadConfig.files = item2[item.zdname];
        this.fileZdname = item.zdname;
        this.tmpChosenData2 = item2;
      } else {
        this.uploadConfig.files = item.value;
        this.tmpChosenData = item;
      }
    },
    tabClickHandle(e, item) {
      for (var i in item.config) {
        if (item.config[i].hasChildren) {
          item.config[i].tabModel = "0";
        }
      }
      if (window["tabChange"]) {
        window["tabChange"](item, item.value[parseInt(item.tabModel)]);
      }
    },
    removeTab(name, arr, item) {
      var n = parseInt(name);
      this.$confirm("将删除此条目，是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // item.tabModel = "0";
          arr.splice(n, 1);
          item.tabModel = arr.length - 1 + "";
          if (window["tabChange"]) {
            window["tabChange"](item, item.value[parseInt(item.tabModel)]);
          }
        })
        .catch(() => {});
    },
    copyItem(item) {
      if (item.value.length) {
        var n = parseInt(item.tabModel);
        item.value.push(JSON.parse(JSON.stringify(item.value[n])));
        item.tabModel = item.value.length - 1 + "";
      } else {
        this.$message.warning("无条目可复制");
      }
    },
    copyItemChild(item, value) {
      if (value.length) {
        var n = parseInt(item.tabModel);
        value.push(value[n]);
      } else {
        this.$message.warning("无条目可复制");
      }
    },
    addItemChild(item, value) {
      var obj = {};
      for (var i in item.config) {
        if (item.config[i].hasChildren) {
          obj[i] = [];
        } else {
          obj[i] = null;
        }
      }
      value.push(obj);
      item.tabModel = value.length - 1 + "";
    },
    addItem(item) {
      var obj = {};
      for (var i in item.config) {
        if (item.config[i].hasChildren) {
          obj[i] = [];
          item.config[i].tabModel = "0";
        } else {
          if (item.config[i].value || item.config[i].value === 0) {
            obj[i] = item.config[i].value;
          } else {
            obj[i] = null;
          }
        }
      }
      item.value.push(obj);
      item.tabModel = item.value.length - 1 + "";
      if (window["tabChange"]) {
        window["tabChange"](item, item.value[parseInt(item.tabModel)]);
      }
    },
    showHandle() {
      if (this.formConfig.type != "C") {
        this.loading = true;
        this.getData();
        setTimeout(() => {
          this.loading = false;
        }, 300);
      }
    },
    async getData() {
      let res = await this.$d[this.formConfig.getDetailUrl](
        this.formConfig.params
      );
      if (res.success) {
        var d = res.data;
        this.d = d;
        var f = this.formConfig.form;
        for (var i in f) {
          f[i]["value"] = d[i];
        }
      } else {
        this.$message.warning(res.msg);
      }
    },
    reset() {
      var f = this.formConfig.form;
      this.formConfig.params = {};
      for (var i in f) {
        if (f[i]["value"] instanceof Array) {
          f[i]["value"] = [];
        } else {
          f[i]["value"] = null;
        }
      }
    },
    hideModel() {
      this.reset();
    },

    getResult() {
      var f = JSON.parse(JSON.stringify(this.formConfig.form));
      var value = {};
      var emptyArr = [];
      var zbRequireObj = {};
      var cbRequireObj = {};
      var selectsArr = [];
      var empty = false;
      for (var i in f) {
        if (f[i].kjlx == "selects") {
          value[i] = f[i].value ? f[i].value.join(",") : null;
        } else {
          value[i] = f[i].value;
        }
        zbRequireObj[i] = f[i].required;

        if (f[i].kjlx == "hasChildren") {
          var c = f[i].config;
          for (var j in c) {
            cbRequireObj[j] = c[j].required;
          }
        }
      }
      for (var i in value) {
        if (value[i] instanceof Array) {
          if (!value[i].length && zbRequireObj[i]) {
            empty = true;
          } else {
            value[i].forEach(e => {
              for (var j in e) {
                if (!e[j] && e[j] !== false && e[j] !== 0 && cbRequireObj[j]) {
                  empty = true;
                }
              }
            });
          }
        } else {
          if (
            !value[i] &&
            value[i] !== false &&
            value[i] !== 0 &&
            zbRequireObj[i]
          ) {
            empty = true;
          }
        }
      }
      if (empty) {
        this.$message.warning("有必填项为空，不能保存！");
        return false;
      } else {
        return value;
      }
    }
  },
  computed: {
    formData() {
      var f = {};
      var mustin = [];
      var d = this.formConfig.form;
      for (var i in d) {
        if (d[i].hasChildren) {
          if (d[i].required && !d[i]["value"].length) {
            mustin.push(d[i].label);
          }
        } else {
          if (d[i].required && !d[i]["value"]) {
            mustin.push(d[i].label);
          }
        }
        f[i] = d[i]["value"];
      }
      if (mustin.length) {
        return {
          valid: false,
          data: mustin.join("，") + "不能为空"
        };
      } else {
        return {
          valid: true,
          data: f
        };
      }
    }
  },
  data() {
    return {
      phoneCodeSec: 60,
      phoneCodeTimer: null,
      showMap: false,
      tmpChosenData: {},
      tmpChosenData2: {},
      tmpPositionObj: {},
      fileZdname: "",
      loading: false,
      uploadConfig: {
        type: "",
        show: false,
        files: "",
        id: "common_upload",
        title: "上传附件",
        fileNoToken: this.formConfig.fileNoToken,
        save: res => {
          if (this.fileZdname) {
            this.tmpChosenData2[this.fileZdname] = res;
          } else {
            this.tmpChosenData.value = res;
          }
          this.uploadConfig.show = false;
          this.fileZdname = "";
        }
      }
    };
  },
  created() {
    var f = this.formConfig.form;
    for (var i in f) {
      if (f[i].hasChildren) {
        var c = f[i].config;
        for (var j in c) {
          if (c[j].value === "") {
            c[j].value = null;
          }
          if (c[j].list&&c[j].list.length) {
            c[j].list.forEach(e => {
              if (e.value === "") {
                e.value = null;
              }
            });
          }
        }
      } else {
        if (f[i].value === "") {
          f[i].value = null;
        }
        if (f[i].list&&f[i].list.length) {
          f[i].list.forEach(e => {
            if (e.value === "") {
                e.value = null;
              }
          });
        }
      }
    }
    window["form"] = this.formConfig;
    window["$http"] = this.$http;
  }
};
</script>

<style lang="scss" scoped>
.form_content_wrap {
  height: 100%;
  background: #ffffff;
  overflow: auto;
  padding: 5px 10px 15px;
}
.form {
  background: #ffffff;
  padding: 5px 10px 15px;
  box-sizing: border-box;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  .form_item {
    display: flex;
    width: 50%;
    padding: 1.3vh 0.5vw;
    align-items: center;
    min-height: 60px;
    .lab {
      flex: 0 0 4vw;
      font-weight: bold;
      color: #409eff;
      margin-right: 0.3vw;
      font-size: 14px;
    }
    .con {
      flex: 1;
      overflow: hidden;
      .con_inp_wrap {
        width: 100%;
        display: flex;
        align-items: center;
      }
      .el-button {
        margin-left: 3px;
      }
      .remark_wrap {
        width: 100%;
        color: #b42f2f;
        font-size: 14px;
        padding-top: 3px;
      }
    }
  }
  .w_33 {
    width: 33% !important;
  }
  .w_80 {
    width: 80% !important;
  }
  .w_100 {
    width: 100% !important;
  }
  .has_child_item {
    width: 100%;
    padding: 0 20px;
    .has_child_item_title {
      color: #409eff;
      font-weight: 700;
      font-size: 17px;
      padding: 10px;
      border: 1px solid #409eff;
      border-left: 5px solid #409eff;
      border-radius: 0 5px 5px 0;
      margin: 10px 0 20px;
      background: #fff;
      box-shadow: 0 0 12px 0 rgba(135, 214, 238, 0.2);
      padding-bottom: 15px;
      .btn_group {
        margin-left: 20px;
        float: right;
      }
    }
  }
}

.form_2_level {
  background: #f0f7fd;
}
.form_3_level {
  background: #dff0fa;
  .con {
    display: flex;
  }
  align-items: center;
}
.required::before {
  content: "* ";
  color: red;
}
.el-tabs {
  background: #ffffff;
}
.my_form {
  width: 100% !important;
}
.tools {
  width: 100%;
}
.fj {
  display: flex;
  align-items: center;
  width: 100%;
  .upload {
    margin-left: 5px;
    display: flex;
  }
}
</style>
